<div class="app-shell" [class.sidebar-collapsed]="sidebarCollapsed()" [class.mobile-sidebar-open]="mobileSidebarOpen()">
  <app-header
    [sidebarCollapsed]="sidebarCollapsed()"
    (menuToggle)="toggleSidebar()"
    (mobileMenuToggle)="openMobileSidebar()"
    (logout)="logout()"
  />
  <app-sidebar
    [collapsed]="sidebarCollapsed()"
    [mobileOpen]="mobileSidebarOpen()"
    (closeMobile)="closeMobileSidebar()"
  />
  <button class="sidebar-backdrop" type="button" aria-label="Close navigation" (click)="closeMobileSidebar()"></button>
  <div *ngIf="routeLoading()" class="route-loader" aria-hidden="true"></div>
  <main class="app-content" id="main-content">
    <div class="page-container">
      <app-breadcrumb />
      <router-outlet />
    </div>
  </main>
  <p-toast position="top-right" />
</div>
